import { IAppConfiguration } from '../cemexng2components/components/app-configuration';

export default [
  {
    feature: 'financial-documents.table-template',
    country: [
      'MX',
      'CO',
      'GB',
      'DE',
      'PA',
      'CR',
      'NI',
      'SV',
      'PR',
      'PE',
      'IL',
      'PH',
      'PL',
      'ES',
      'LV',
      'CZ',
      'FR',
      'EG'
    ],
    options: {
      columns: {
        active: [
          'invoiceReviewed',
          'referenceNumber',
          'docStatusDesc',
          'jobSiteDesc',
          'documentTypeDesc',
          'dueDateObj',
          'createDateObj',
          'amount',
          'balance'
        ],
        inactive: [
          'documentCode',
          'disputeCode',
          'disputeCompromiseDateObj',
          'disputeStatusDesc',
          'relatedDocument',
          'contract',
          'purchaseOrder',
          'jobSiteCode',
          'customerJobsiteNumber',
          'plantDesc',
          'salesOfficeCode'
        ],
        debug: ['documentTypeCode']
      },
    }
  },
  {
    feature: 'financial-documents.table-template-fr',
    country: ['FR'],
    options: {
      columns: {
        active: [
          'invoiceReviewed',
          'docStatusDesc',
          'referenceNumber',
          'jobSiteDesc',
          'plantDesc',
          'salesOrgCode',
          'documentTypeDesc',
          'dueDateObj',
          'createDateObj',
          'amount',
          'balance'
        ],
        inactive: [
          'documentCode',
          'disputeCode',
          'disputeCompromiseDateObj',
          'disputeStatusDesc',
          'relatedDocument',
          'contract',
          'purchaseOrder',
          'jobSiteCode',
          'customerJobsiteNumber',
          'salesOfficeCode',
          'balance'
        ],
        hidden: ['balance', 'discount', 'ppdDueDate'],
        debug: ['documentTypeCode']
      }
    }
  },
  {
    feature: 'financial-documents.table-template-us',
    country: ['US'],
    options: {
      columns: {
        active: [
          'invoiceReviewed',
          'documentCode',
          'docStatusDesc',
          'relatedDocument',
          'jobSiteDesc',
          'documentTypeDesc',
          'dueDateObj',
          'createDateObj',
          'balance'
        ],
        inactive: [
          'disputeCode',
          'disputeCompromiseDateObj',
          'disputeStatusDesc',
          'contract',
          'purchaseOrder',
          'jobSiteCode',
          'customerJobsiteNumber',
          'plantDesc',
          'salesOfficeCode',
          'amount',
          'discount',
          'ppdDueDate'
        ],
        hidden: ['referenceNumber', 'discount', 'ppdDueDate'],
        debug: ['documentTypeCode']
      }
    }
  },
  {
    feature: 'financial-documents.table-template-es',
    country: ['ES'],
    options: {
      columns: {
        active: [
          'docStatusDesc',
          'referenceNumber',
          'jobSiteDesc',
          'plantDesc',
          'salesOfficeCode',
          'documentTypeDesc',
          'dueDateObj',
          'createDateObj',
          'amount',
          'jobSiteCode'
        ],
        inactive: [
          'invoiceReviewed',
          'documentCode',
          'disputeCode',
          'disputeCompromiseDateObj',
          'disputeStatusDesc',
          'relatedDocument',
          'customerJobsiteNumber',
          'balance',
          'contract',
          'purchaseOrder'
        ],
        hidden: ['discount', 'ppdDueDate'],
        debug: ['documentTypeCode']
      }
    }
  },
  {
    feature: 'financial-documents.table-template-lv',
    country: ['LV'],
    options: {
      columns: {
        active: [
          'docStatusDesc',
          'referenceNumber',
          'jobSiteDesc',
          'plantDesc',
          'documentTypeDesc',
          'dueDateObj',
          'createDateObj',
          'amount',
          'balance'
        ],
        inactive: [
          'invoiceReviewed',
          'documentCode',
          'disputeCode',
          'disputeCompromiseDateObj',
          'disputeStatusDesc',
          'relatedDocument',
          'customerJobsiteNumber',
          'contract',
          'purchaseOrder',
          'jobSiteCode',
          'salesOfficeCode'
        ],
        hidden: ['discount', 'ppdDueDate'],
        debug: ['documentTypeCode']
      }
    }
  },
  {
    feature: 'financial-documents.table-template-cz',
    country: ['CZ'],
    options: {
      columns: {
        active: [
          'invoiceReviewed',
          'referenceNumber',
          'docStatusDesc',
          'jobSiteDesc',
          'documentTypeDesc',
          'dueDateObj',
          'createDateObj',
          'amount'
        ],
        inactive: [
          'balance',
          'documentCode',
          'disputeCode',
          'disputeCompromiseDateObj',
          'disputeStatusDesc',
          'relatedDocument',
          'contract',
          'purchaseOrder',
          'jobSiteCode',
          'customerJobsiteNumber',
          'plantDesc',
          'salesOfficeCode',
          'discount',
          'ppdDueDate'
        ],
        debug: ['documentTypeCode']
      }
    }
  },
  {
    feature: 'financial-documents.table-template-ae',
    country: ['AE'],
    options: {
      columns: {
        active: [
          'invoiceReviewed',
          'referenceNumber',
          'docStatusDesc',
          'jobSiteCode',
          'jobSiteDesc',
          'documentTypeDesc',
          'dueDateObj',
          'createDateObj',
          'amount',
          'balance'
        ],
        inactive: [
          'documentCode',
          'disputeCode',
          'disputeCompromiseDateObj',
          'disputeStatusDesc',
          'relatedDocument',
          'contract',
          'purchaseOrder',
          'customerJobsiteNumber',
          'plantDesc',
          'salesOfficeCode'
        ],
        debug: ['documentTypeCode']
      }
    }
  },
  {
    feature: 'financial-documents.table-template-do',
    country: ['DO'],
    options: {
      columns: {
        active: [
          'invoiceReviewed',
          'referenceNumber',
          'docStatusDesc',
          'jobSiteDesc',
          'documentTypeDesc',
          'dueDateObj',
          'createDateObj',
          'amount',
          'balance',
          'fiscalControlNumber'
        ],
        inactive: [
          'documentCode',
          'disputeCode',
          'disputeCompromiseDateObj',
          'disputeStatusDesc',
          'relatedDocument',
          'contract',
          'purchaseOrder',
          'jobSiteCode',
          'customerJobsiteNumber',
          'plantDesc',
          'salesOfficeCode'
        ],
        debug: ['documentTypeCode']
      }
    }
  },
  {
    feature: 'financial-documents.table-template-gt',
    country: ['GT'],
    options: {
      columns: {
        active: [
          'invoiceReviewed',
          'referenceNumber',
          'docStatusDesc',
          'jobSiteDesc',
          'documentTypeDesc',
          'dueDateObj',
          'createDateObj',
          'amount',
          'balance',
          'fiscalControlNumber'
        ],
        inactive: [
          'documentCode',
          'disputeCode',
          'disputeCompromiseDateObj',
          'disputeStatusDesc',
          'relatedDocument',
          'contract',
          'purchaseOrder',
          'jobSiteCode',
          'customerJobsiteNumber',
          'plantDesc',
          'salesOfficeCode'
        ],
        debug: ['documentTypeCode']
      }
    }
  }
] as IAppConfiguration[];
